import React = require('react');
import { IChannel } from '../../../../../../data/api/models';
import { get } from 'lodash';

interface IAggregatorDisplayProps {
  channel: IChannel;
}

export const AggregatorDisplay = ({ channel }: IAggregatorDisplayProps) => {

  const logoLink = get(channel, 'channelLogo') ? get(channel, 'channelLogo') : (get(channel, 'additionalLogo') ? get(channel, 'additionalLogo') : null)

  return (
    <div className={'display-container'}>
      {logoLink && (
        <>
          <div className={'text'}>Your details have been collected from</div>
          <div className={'logo'}><img width={'100px'} src={logoLink} alt="Admiral"/></div>
        </>
      )}

      {!logoLink && (
        <>
          <div className={'text'}>Your details have been collected from {get(channel, 'name')}</div>
        </>
      )}
    </div>
  )
}
